<template>
  <button
    @click="saveDesign"
    :disabled="disableSaveDesignButton || disableSaveDesign"
    :class="[
      'button',
      'secondary',
      'buy-panel-save-design',
      { 'buy-panel-add-to-cart-loading': saveDesignLoading, 'full-width': ((isUGCApplied && !tmallIsUGCMS) || onlyFavorites) }
    ]"
    type="button"
  >
    <span v-show="!saveDesignLoading">{{ translations.buyPanelTmallSaveDesign }}</span>
    <base-spinner
      v-show="saveDesignLoading"
      size="40"
      class="buy-panel-add-to-cart-spinner"
    ></base-spinner>
  </button>
</template>
<script>
import baseSpinner from "@/components/Spinner";

export default {
  name: "saveDesign",
  components: {
    baseSpinner
  },
  props: {
    type: {
      type: String,
      default: "customizer"
    },
    isUGCApplied: {
      type: Boolean,
      default: false
    },
    tmallIsUGCMS: {
      type: Boolean,
      default: false
    },
    onlyFavorites: {
      type: Boolean,
      default: false
    },
    isWishlistButtonEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      disableSaveDesignButton: false,
      saveDesignLoading: false
    };
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    itemsToPurchase() {
      return this.$store.state.buyPanel.itemsToPurchase;
    },
    disableSaveDesign() {
      let disableButton = false;
      this.itemsToPurchase.forEach(item => {
        if (item.size === "") {
          disableButton = true;
        }
      });
      return disableButton;
    },
    ugcSize() {
      return this.$store.state.buyPanel.ugcSize;
    },
    sizes() {
      return this.$store.state.utils.audienceSizes;
    }
  },
  methods: {
    toggleAddToCartState(disable) {
      this.disableSaveDesignButton = disable;
    },
    /**
     * @function saveDesign
     * Save the design using request data.
     */
    saveDesign() {
      if (this.isWishlistButtonEnabled) {
        this.disableSaveDesignButton = true;
        this.$eventBus.$emit("enable-add-to-cart-button", false);
      }
      this.saveDesignLoading = true;
      if (!this.areValidItemsToPurchase()) {
        this.saveDesignLoading = false;
        this.openRepositionWarningModal();
        return;
      }
      this.$eventBus.$emit("tmall-save-design");
    },
    enableButtons() {
      this.saveDesignLoading = false;
      this.disableSaveDesignButton = false;
    },
    openRepositionWarningModal() {
      this.$eventBus.$emit("hide-buy-panel");
      this.$modal.show(
        !!this.$store.state.utils.configuration.modals?.ugcRepositionWarning
          ? "ugcRepositionWarningModal"
          : "NewRepositionWarningModal",
        {
          newUGCSize: this.getTextSize(this.itemsToPurchase[0].size),
          prevUGCSize: this.getTextSize(this.ugcSize),
          sizeIdentifierValue: this.itemsToPurchase[0].size,
          deletePreviousRecipe: true,
          storeMultipleUGCsizes: true
        }
      );
    },
    areValidItemsToPurchase() {
      if(this.$store.state.utils.configuration.ugc.disableSizeSelector) return true;
      const isUGC = this.$recipe.checkUGCByType({ customUGC: true });
      if (isUGC && this.itemsToPurchase[0].size != this.ugcSize) {
        return false;
      }
      return true;
    },
    getTextSize(identifierSize) {
      const ugcSizeIndex = this.sizes.identifier.indexOf(identifierSize);
      return ugcSizeIndex >= 0
        ? this.sizes.values[ugcSizeIndex]
        : identifierSize;
    }
  },
  created() {
    this.$eventBus.$on("buypanel-open", this.enableButtons);
    this.$eventBus.$on('tmall-wishlist-saved', this.enableButtons);
    this.$eventBus.$on('hide-buy-panel', this.enableButtons);
    if (this.isWishlistButtonEnabled) {
      this.$eventBus.$on('toggle-save-design-button', this.toggleAddToCartState);
    }
  },
  beforeDestroy() {
    this.$eventBus.$off("buypanel-open", this.enableButtons);
    this.$eventBus.$off('tmall-wishlist-saved', this.enableButtons);
    this.$eventBus.$off('hide-buy-panel', this.enableButtons);
    if (this.isWishlistButtonEnabled) {
      this.$eventBus.$off('toggle-save-design-button', this.toggleAddToCartState);
    }
  }
};
</script>
